// extracted by mini-css-extract-plugin
export default {"title":"NoteTitle_title__8nCok"};